import React from 'react';
import { Menu } from 'antd';
import { HomeFilled, CheckCircleOutlined, CalculatorOutlined, CarFilled, CreditCardOutlined, TeamOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const items2 = [
    {
      key: '1',
      icon: React.createElement(HomeFilled),
      label: <Link to="/">Գլխավոր</Link>
    },
    {
      key: '2',
      icon: React.createElement(CheckCircleOutlined),
      label: 'Աշխատանքներ',
      children: [
        {
            key: 'done',
            label: <Link to='/done'>Կատարված</Link>
        },
        {
            key: 'add',
            label: <Link to='/add'>Ավելացնել</Link>,
        },
      ],
    },
    {
      key: '3',
      icon: React.createElement(CalculatorOutlined),
      label: <Link to="/transaction">Հաշվարկներ</Link>
    },
    {
      key: '4',
      icon: <CreditCardOutlined />,
      label: 'Յուղեր',
      children: [
        {
            key: 'oil-done',
            label: <Link to='/oil-done'>Փոխարինված</Link>
        },
        {
          key: 'oil-blank',
          label: <Link to='/oil-blank'>Լրացնել բլանկ</Link>
      }
      ],
    },
    {
      key: '5',
      icon: <CarFilled />,
      label: <Link to="/cars">Մեքենաներ</Link>
    },
    {
      key: '6',
      icon: <TeamOutlined />,
      label: <Link to="/team">Մեր թիմը</Link>
    },
  ];

const Sidebar = () => {
  return (
    <div style={{ position: 'sticky', top: 0, height: '100vh', zIndex: 100 }}>
      <Menu
        mode="inline"
        defaultSelectedKeys={['1']}
        defaultOpenKeys={['sub1']}
        style={{
          height: '100%',
          borderRight: 0,
        }}
        items={items2}
      />
  </div>
  );
};

export default Sidebar;
